import React from "react";
import { Popup, Button } from "devextreme-react";

class Modal extends React.PureComponent {
  render() {
    const {
      open,
      onClose,
      title,
      height,
      width,
      body,
      handleSuccess,
      disableNext,
      isLastPage,
      type,
      acceptText,
      cancelText,
      handleRechazo
    } = this.props;
    let cancelButtonStyle = {
      paddingLeft: 25,
      paddingRight: 25,
      // backgroundColor: "grey",
      // color: "white",
    };

    let buttonStyle = {
      paddingLeft: 25,
      paddingRight: 25,
    };

    // let titleStyle = {
    //   width: "100%",
    //   fontSize: 20,
    //   fontWeight: "bold",
    //   textAlign: "center",
    //   color: "#007A33",
    // };

    const bodyStyle = {
      width: "100%",
      textAlign: "center",
      fontSize: 15,
      padding: 0,
      paddingTop: 5,
      paddingBottom: 5,
    };

    let buttonType = "success";
    let cancelType = "normal";
    if (type === "del") {
      // titleStyle = { ...titleStyle, color: "red" };
      buttonStyle = { ...buttonStyle, color: "white" };
      buttonType = "danger";
    } else if (type === "gestion") {
      cancelButtonStyle = { ...cancelButtonStyle, backgroundColor: "" };
      cancelType = "danger";
    }
    return (
      <Popup
        visible={open}
        height={height || "200px"}
        onHiding={onClose}
        showCloseButton
        maxWidth={width || "600px"}
        showTitle
        dragEnabled={false}
        title={title}
        contentRender={() => (
          <div className="row" style={{ margin: 0, padding: 0 }}>
            <div className="col-12" style={{ justifyContent: "center" }}>
              <div className="row" style={{ margin: 0, padding: 0 }}>
                <div className="col-12" style={bodyStyle}>
                  {body}
                </div>
              </div>
              <div className="row">
                <div
                  className="col-12"
                  style={{
                    width: "92%", textAlign: "center", position: "fixed", bottom: 25,
                  }}
                >

                      <Button
                        disabled={disableNext && title !== "Nueva solicitud"}
                        text={cancelText || "Cancelar"}
                        type={cancelType}
                        onClick={handleRechazo}
                        style={{ ...cancelButtonStyle, marginRight: 20 }}
                      />
                      <Button
                        disabled={disableNext}
                        text={acceptText || "Guardar"}
                        type={buttonType}
                        style={buttonStyle}
                        onClick={handleSuccess}
                      />
                </div>
              </div>
            </div>

          </div>)
        }
      />
    );
  }
}

export default Modal;
